module.exports = __webpack_public_path__ + "static/media/img8.3aaa6d71.jpg";